import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'

import { renderCell } from './RentalPortalArchiveTableRow.utils'

import * as styles from './RentalPortalArchiveTableRow.module.css'

function RentalPortalArchiveTableRow({
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleCallAction, handleMouseEnter, handleMouseLeave, handleSelect } =
    useTableRowActions({ item, ...restProps })

  const className = useTableRowModClassName({
    className: styles.RentalPortalArchiveTableRow,
    isSelected,
  })

  return (
    <div
      {...getTableRowQaProps()}
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <TableRowActions
        disabled={hideCheckbox}
        selected={isSelected}
        width={actionsColumnWidth}
        onChange={handleSelect}
      />
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            t,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default RentalPortalArchiveTableRow
